import React, { useState, useRef, useEffect } from "react";
import OfferForm from "./components/OfferForm";
import SavedOffersPage from "./components/SavedOffersPage";
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, useLocation, Navigate, Outlet } from "react-router-dom";
import { Cog6ToothIcon } from '@heroicons/react/24/outline';
import { CurrencyDollarIcon, CurrencyEuroIcon } from '@heroicons/react/24/outline';
import Login from './components/Login';
import './i18n';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from './i18n';
import WizardModal from "./components/WizardModal";
import { PlusIcon } from '@heroicons/react/24/solid';
import TeklifDashboard from "./components/TeklifDashboard";
import UrunListesiPage from './components/UrunListesiPage';
import PartnerlerPage from './components/PartnerlerPage';
import ProformaPage from './components/ProformaPage';
import ProformaOlusturPage from './components/ProformaOlusturPage';
import SatislarPage from './components/SatislarPage';
import UretimPage from './components/UretimPage';
import SutFiyatlariPage from './components/SutFiyatlariPage';
import { UserProvider, useUser } from "./components/UserContext";
import LoginPage from "./components/LoginPage";
import TeklifOlusturPage from './components/TeklifOlusturPage';
import GuestFirmalarPage from './components/GuestFirmalarPage';
import GuestTekliflerPage from './components/GuestTekliflerPage';
import GuestAccessPage from './components/GuestAccessPage';
import TeklifDegerlendirPage from './components/TeklifDegerlendirPage';
import AdminSidebar from './components/AdminSidebar';
import LogsPage from './components/LogsPage';
import SutKutuphanesiPage from './components/SutKutuphanesiPage';
import AdminTemporaryLinksPage from './components/AdminTemporaryLinksPage';
import AdminPanel from './components/AdminPanel';
import AdminImportExport from './components/AdminImportExport';
import LojistikPage from './components/LojistikPage';
import { LanguageProvider } from './contexts/LanguageContext';
import FirmaSecimModal from './components/FirmaSecimModal';
import UserProfile from './components/UserProfile';
import OdemeDetaylariPage from './components/OdemeDetaylariPage';
import ErrorBoundary from './components/ErrorBoundary';
import HelpPage from './components/HelpPage';
import AdminHelpPage from './components/AdminHelpPage';
import AdminMailingPage from './components/AdminMailingPage';
import TourEditorOverlay from './components/TourEditorOverlay';
import FloatingHelpButton from './components/FloatingHelpButton';

function PrivateRoute() {
  const { user } = useUser();
  const location = useLocation();
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  return <Outlet />;
}

function AppRoutes(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    showWizard,
    setShowWizard,
    wizardSettings,
    setSelectedOfferId,
    setSelectedOfferMode,
    selectedOfferId,
    selectedOfferMode,
    onNewOffer,
    changeLang,
    setCurrency,
    setOfferType
  } = props;

  const handleWizardSubmit = (settings) => {
    props.setWizardSettings(settings);
    setShowWizard(false);
    setSelectedOfferId(null);
    setSelectedOfferMode(null);
    localStorage.removeItem('selectedOfferId');
    localStorage.removeItem('selectedOfferMode');
    if (settings.lang) {
      changeLang(settings.lang);
    }
    setCurrency(settings.currency);
    setOfferType(settings.offerType);
    setTimeout(() => navigate('/teklif'), 0);
  };

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/teklif-olustur" element={<TeklifOlusturPage />} />
      <Route path="/dash/:view" element={<TeklifOlusturPage />} />
      <Route path="/admin/guest-firmalar" element={<GuestFirmalarPage />} />
      <Route path="/admin/guest-teklifler" element={<GuestTekliflerPage />} />
      <Route path="/admin/temporary-links" element={<AdminTemporaryLinksPage />} />
      <Route path="/guest-access/:token" element={<GuestAccessPage />} />
      <Route path="/admin/teklif-degerlendir/:id" element={<TeklifDegerlendirPage />} />
      <Route path="/admin/applications" element={<AdminPanel />} />
      <Route path="/admin/import-export" element={<AdminImportExport />} />
      <Route path="/yardim" element={<HelpPage />} />
      <Route path="/admin/help" element={<AdminHelpPage />} />
      <Route path="/admin/mailing" element={<AdminMailingPage />} />
      <Route path="/logs" element={<LogsPage />} />
      <Route path="/sut-kutuphanesi" element={<SutKutuphanesiPage />} />
      <Route path="/lojistik" element={<LojistikPage />} />
      <Route path="/" element={<Navigate to="/dash" replace />} />
      <Route element={<PrivateRoute />}>
        <Route path="/dash" element={<TeklifDashboard onNewOffer={onNewOffer} />} />
        <Route path="/teklif" element={
          !showWizard ? (
            <OfferForm
              currency={wizardSettings.currency}
              lang={wizardSettings.lang}
              offerType={wizardSettings.offerType}
              recipient={wizardSettings.recipient}
              onClose={() => { setShowWizard(true); setSelectedOfferId(null); setSelectedOfferMode(null); localStorage.removeItem('selectedOfferId'); localStorage.removeItem('selectedOfferMode'); }}
              onDelete={() => {
                localStorage.removeItem('offerDraft');
                setShowWizard(true);
                setSelectedOfferId(null);
                setSelectedOfferMode(null);
                localStorage.removeItem('selectedOfferId');
                localStorage.removeItem('selectedOfferMode');
                navigate('/dash');
              }}
              readonly={selectedOfferId ? selectedOfferMode === 'view' : false}
              editMode={selectedOfferId ? selectedOfferMode === 'edit' : false}
              selectedOfferId={selectedOfferId}
              onSave={() => { setSelectedOfferId(null); setSelectedOfferMode(null); localStorage.removeItem('selectedOfferId'); localStorage.removeItem('selectedOfferMode'); }}
              onEditWizard={() => setShowWizard(true)}
            />
          ) : null
        } />
        <Route path="/kayitli-teklifler" element={<SavedOffersPage />} />
        <Route path="/hesabim" element={<UserProfile />} />
        <Route path="/odeme-detaylari" element={<OdemeDetaylariPage />} />
        <Route path="/urunler" element={<UrunListesiPage />} />
        <Route path="/partnerler" element={<PartnerlerPage />} />
        <Route path="/proforma" element={<ProformaPage />} />
        <Route path="/proforma-olustur" element={<ProformaOlusturPage />} />
        <Route path="/satislar" element={<SatislarPage />} />
        <Route path="/uretim" element={<UretimPage />} />
        <Route path="/sut-fiyatlari" element={<SutFiyatlariPage />} />
      </Route>
    </Routes>
  );
}

function AppContent() {
  const { user, logout, selectedFirma, selectFirma, showFirmaSecimModal, setShowFirmaSecimModal } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const userDropdownRef = useRef(null);
  const [firmaDropdownOpen, setFirmaDropdownOpen] = useState(false);
  const firmaDropdownRef = useRef(null);
  const [langDropdownOpen, setLangDropdownOpen] = useState(false);
  const [selectedLang, setSelectedLang] = useState('TR');
  const langDropdownRef = useRef(null);
  const [currency, setCurrency] = useState('TRY');
  const currencySymbols = { TRY: '₺', USD: '$', EUR: '€' };
  const currencyIcons = {
    TRY: null,
    USD: CurrencyDollarIcon,
    EUR: CurrencyEuroIcon,
  }; 
  const [realRates, setRealRates] = useState({ USD: 32, EUR: 35 });
  const [customRates, setCustomRates] = useState({ USD: 32, EUR: 35 });
  const [showRateModal, setShowRateModal] = useState(false);
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'light');
  const [settingsTab, setSettingsTab] = useState('theme');
  const [offerType, setOfferType] = useState('yurtiçi');
  const { t, i18n } = useTranslation();

  const changeLang = (lng) => {
    changeLanguage(lng);
    setSelectedLang(lng);
  };

  const [showWizard, setShowWizard] = useState(false);
  const [wizardSettings, setWizardSettings] = useState({ currency: 'TRY', lang: 'TR', offerType: 'yurtiçi' });

  const handleNewOffer = () => {
    navigate('/teklif-olustur');
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (userDropdownRef.current && !userDropdownRef.current.contains(event.target)) {
        setUserDropdownOpen(false);
      }
      if (langDropdownRef.current && !langDropdownRef.current.contains(event.target)) {
        setLangDropdownOpen(false);
      }
      if (firmaDropdownRef.current && !firmaDropdownRef.current.contains(event.target)) {
        setFirmaDropdownOpen(false);
      }
    }
    if (userDropdownOpen || langDropdownOpen || firmaDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [userDropdownOpen, langDropdownOpen, firmaDropdownOpen]);

  useEffect(() => {
    fetch('https://api.exchangerate.host/latest?base=TRY&symbols=USD,EUR')
      .then(res => {
        if (!res.ok) throw new Error('Exchange rate API error');
        return res.json();
      })
      .then(data => {
        if (data && data.rates) {
          const usd = data.rates.USD ? 1 / data.rates.USD : 32;
          const eur = data.rates.EUR ? 1 / data.rates.EUR : 35;
          setRealRates({ USD: Number(usd.toFixed(2)), EUR: Number(eur.toFixed(2)) });
          setCustomRates(prev => ({ USD: prev.USD || Number(usd.toFixed(2)), EUR: prev.EUR || Number(eur.toFixed(2)) }));
        }
      })
      .catch(() => {
        setRealRates({ USD: 32, EUR: 35 });
        setCustomRates(prev => ({ USD: prev.USD || 32, EUR: prev.EUR || 35 }));
      });
  }, []);

  const [selectedOfferId, setSelectedOfferId] = useState(() => localStorage.getItem('selectedOfferId'));
  const [selectedOfferMode, setSelectedOfferMode] = useState(() => localStorage.getItem('selectedOfferMode'));
  
  useEffect(() => {
    const id = localStorage.getItem('selectedOfferId');
    const mode = localStorage.getItem('selectedOfferMode');
    setSelectedOfferId(id);
    setSelectedOfferMode(mode);
  }, [showWizard]);

  useEffect(() => {
    document.body.classList.toggle('dark', theme === 'dark');
    localStorage.setItem('theme', theme);
  }, [theme]);

  if (!user) {
    return (
      <>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/teklif-olustur" element={<TeklifOlusturPage />} />
          <Route path="/guest-access/:token" element={<GuestAccessPage />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
        <FloatingHelpButton />
      </>
    );
  }

  // /dash/:view alt sayfaları (hesabim, sepetim, vb.) — TeklifOlusturPage layout'u
  if (location.pathname === '/teklif-olustur' || /^\/dash\/.+/.test(location.pathname)) {
    return (
      <>
        <Routes>
          <Route path="/teklif-olustur" element={<TeklifOlusturPage />} />
          <Route path="/dash/:view" element={<TeklifOlusturPage />} />
        </Routes>
        <FloatingHelpButton />
        <TourEditorOverlay />
      </>
    );
  }

  // Ana sayfa ve /dash/ (trailing slash) -> /dash'e yönlendir
  if (location.pathname === '/' || location.pathname === '/dash/') {
    return (
      <Routes>
        <Route path="*" element={<Navigate to="/dash" replace />} />
      </Routes>
    );
  }

  // Dashboard kendi layout'unu kullanır (TeklifOlusturPage gibi standalone)
  if (location.pathname === '/dash') {
    return (
      <>
        <Routes>
          <Route path="/dash" element={<TeklifDashboard onNewOffer={handleNewOffer} />} />
        </Routes>
        <FirmaSecimModal />
        <FloatingHelpButton />
        <TourEditorOverlay />
      </>
    );
  }

  return (
    <>
      {location.pathname !== '/teklif-olustur' && (
        user?.role === 'admin'
          ? <AdminSidebar />
          : (
            <nav className="w-full fixed top-0 left-0 z-40 bg-white px-0 py-0 shadow-[0_2px_8px_rgba(0,0,0,0.06)]">
              <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-0 px-2 sm:px-6 py-2 sm:py-4">
                <div className="flex items-center gap-2 sm:gap-3">
                  <span className="text-lg sm:text-xl font-bold tracking-wide text-blue-900 select-none cursor-default">Order</span>
                </div>
                <div className="flex-1 flex items-center justify-center w-full">
                  <div className="flex gap-1 sm:gap-4 items-center justify-center w-full">
                    {user?.role === 'partner' ? (
                      <>
                        <Link to="/dash" className="relative transition-all duration-200 px-3 sm:px-5 py-2 rounded-xl font-semibold tracking-wide focus:outline-none focus:ring-2 focus:ring-blue-200 overflow-hidden text-sm sm:text-base text-blue-800 hover:bg-[#eaf7fe] hover:text-blue-600">
                          <span className="z-10 relative">Başvurularım</span>
                        </Link>
                        <Link to="/profil" className="relative transition-all duration-200 px-3 sm:px-5 py-2 rounded-xl font-semibold tracking-wide focus:outline-none focus:ring-2 focus:ring-blue-200 overflow-hidden text-sm sm:text-base text-blue-800 hover:bg-[#eaf7fe] hover:text-blue-600">
                          <span className="z-10 relative">Profilim</span>
                        </Link>
                        <Link to="/destek" className="relative transition-all duration-200 px-3 sm:px-5 py-2 rounded-xl font-semibold tracking-wide focus:outline-none focus:ring-2 focus:ring-blue-200 overflow-hidden text-sm sm:text-base text-blue-800 hover:bg-[#eaf7fe] hover:text-blue-600">
                          <span className="z-10 relative">Destek</span>
                        </Link>
                      </>
                    ) : (
                      <>
                        
                        {user?.role === 'admin' && (
                          <>
                            <Link to="/admin/guest-firmalar" className="relative transition-all duration-200 px-3 sm:px-5 py-2 rounded-xl font-semibold tracking-wide focus:outline-none focus:ring-2 focus:ring-blue-200 overflow-hidden text-sm sm:text-base text-blue-800 hover:bg-[#eaf7fe] hover:text-blue-600">
                              <span className="z-10 relative">Misafir Firmalar</span>
                            </Link>
                            <Link to="/admin/guest-teklifler" className="relative transition-all duration-200 px-3 sm:px-5 py-2 rounded-xl font-semibold tracking-wide focus:outline-none focus:ring-2 focus:ring-blue-200 overflow-hidden text-sm sm:text-base text-blue-800 hover:bg-[#eaf7fe] hover:text-blue-600">
                              <span className="z-10 relative">Misafir Teklifler</span>
                            </Link>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
                <div className="flex items-center gap-1 sm:gap-2 ml-0 sm:ml-2">
                 
                  {/* Guest kullanıcılar için Sipariş Oluştur butonu */}
                  {user?.type === 'guest' && (
                    <button
                      onClick={() => navigate('/teklif-olustur')}
                      className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-2 rounded-xl bg-blue-600 hover:bg-blue-700 transition text-white font-semibold focus:outline-none focus:ring-2 focus:ring-blue-200 text-sm sm:text-base"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
                      </svg>
                      <span className="hidden sm:inline">Sipariş Oluştur</span>
                    </button>
                  )}

                  {/* Firma Seçici Dropdown */}
                  {user?.firmalar && user.firmalar.length > 1 && selectedFirma && (
                    <div className="relative" ref={firmaDropdownRef}>
                      <button
                        className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-2 rounded-xl bg-amber-50 hover:bg-amber-100 transition text-amber-800 font-semibold focus:outline-none focus:ring-2 focus:ring-amber-200 text-sm border border-amber-200"
                        onClick={() => setFirmaDropdownOpen((v) => !v)}
                      >
                        <svg className="w-4 h-4 text-amber-600" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 0h.008v.008h-.008V7.5Z" />
                        </svg>
                        <span className="hidden sm:inline max-w-[120px] truncate">{selectedFirma.firma}</span>
                        <svg className={`w-3.5 h-3.5 transition-transform text-amber-700 ${firmaDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" /></svg>
                      </button>
                      {firmaDropdownOpen && (
                        <div className="absolute right-0 mt-2 w-64 bg-white border border-amber-100 rounded-xl shadow-xl py-2 z-50 animate-fade-in">
                          <div className="px-3 py-1.5 text-[10px] font-bold text-amber-600 uppercase tracking-wider">Firma Değiştir</div>
                          {user.firmalar.map((f) => (
                            <button
                              key={f.id}
                              onClick={() => { selectFirma(f); setFirmaDropdownOpen(false); }}
                              className={`w-full text-left px-3 py-2 flex items-center gap-2 transition ${
                                selectedFirma?.id === f.id
                                  ? 'bg-amber-50 text-amber-900 font-semibold'
                                  : 'text-gray-700 hover:bg-amber-50 hover:text-amber-900'
                              }`}
                            >
                              <span className={`w-6 h-6 flex items-center justify-center rounded-full text-[10px] font-bold flex-shrink-0 ${
                                selectedFirma?.id === f.id ? 'bg-amber-600 text-white' : 'bg-gray-200 text-gray-600'
                              }`}>
                                {(f.firma || '?')[0].toUpperCase()}
                              </span>
                              <span className="truncate text-sm">{f.firma}</span>
                              {selectedFirma?.id === f.id && (
                                <svg className="w-4 h-4 text-amber-600 ml-auto flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                                  <path fillRule="evenodd" d="M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z" clipRule="evenodd" />
                                </svg>
                              )}
                            </button>
                          ))}
                          <div className="border-t border-amber-100 mt-1 pt-1 px-3">
                            <button
                              onClick={() => { setShowFirmaSecimModal(true); setFirmaDropdownOpen(false); }}
                              className="w-full text-left py-1.5 text-xs text-amber-600 hover:text-amber-800 font-medium transition"
                            >
                              Tüm Firmaları Görüntüle...
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                 
                  <div className="relative" ref={userDropdownRef}>
                    <button
                      className="flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-2 rounded-xl bg-[#eaf7fe] hover:bg-blue-50 transition text-blue-800 font-semibold focus:outline-none focus:ring-2 focus:ring-blue-200 text-sm sm:text-base"
                      onClick={() => setUserDropdownOpen((v) => !v)}
                    >
                      <span className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center rounded-full bg-blue-200 text-blue-900 font-bold text-base sm:text-lg select-none">
                        {user?.type === 'guest' ? (user?.firma?.[0] || user?.email?.[0] || 'M') : (user?.name?.[0] || 'M')}
                      </span>
                      <span className="hidden sm:inline">
                        {user?.type === 'guest' ? (user?.firma || user?.email || 'Misafir') : (user?.name || 'Misafir')}
                      </span>
                      {user?.type === 'guest' && (
                        <span className="text-yellow-600 text-xs font-bold border border-yellow-400 rounded px-1 py-0.5 ml-1">Misafir</span>
                      )}
                      <svg className={`w-4 h-4 ml-1 transition-transform text-blue-800 ${userDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" /></svg>
                    </button>
                    {userDropdownOpen && (
                      <div className="absolute right-0 mt-2 w-36 sm:w-40 bg-white border border-blue-100 rounded-xl shadow-lg py-2 z-50 animate-fade-in">
                        <button className="w-full text-left px-4 py-2 text-blue-800 hover:bg-[#eaf7fe] hover:text-blue-900 transition cursor-pointer" onClick={() => logout()}>Çıkış Yap</button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </nav>
          )
        )}
      {showWizard && location.pathname === '/teklif' && (
        <WizardModal
          open={showWizard}
          onClose={() => setShowWizard(false)}
          onSubmit={(settings) => {
            setWizardSettings(settings);
            setShowWizard(false);
            setSelectedOfferId(null);
            setSelectedOfferMode(null);
            localStorage.removeItem('selectedOfferId');
            localStorage.removeItem('selectedOfferMode');
            if (settings.lang) changeLang(settings.lang);
            setCurrency(settings.currency);
            setOfferType(settings.offerType);
            setTimeout(() => { if (window.location.pathname !== '/teklif') navigate('/teklif'); }, 0);
          }}
        />
      )}
      <div
        style={{
          paddingTop: location.pathname !== '/teklif-olustur' ? 72 : 0,
          width: user?.role === 'admin' ? 'calc(100vw - 256px)' : '100%',
          marginLeft: user?.role === 'admin' ? 256 : 0,
          minHeight: '100vh',
          transition: 'all 0.2s cubic-bezier(.4,0,.2,1)'
        }}
      >
        <AppRoutes
          showWizard={showWizard}
          setShowWizard={setShowWizard}
          wizardSettings={wizardSettings}
          setWizardSettings={setWizardSettings}
          setSelectedOfferId={setSelectedOfferId}
          setSelectedOfferMode={setSelectedOfferMode}
          selectedOfferId={selectedOfferId}
          selectedOfferMode={selectedOfferMode}
          onNewOffer={handleNewOffer}
          changeLang={changeLang}
          setCurrency={setCurrency}
          setOfferType={setOfferType}
        />
      </div>
      <footer className="w-full bg-[#f3f6fa] text-gray-500 text-xs text-center py-3 sm:py-4 mt-10 border-t border-blue-50">
        © 2025 INVAMED. Tüm hakları saklıdır.
      </footer>
      {/* Firma Seçim Modalı */}
      <FirmaSecimModal />
      <FloatingHelpButton />
      {/* Tur Düzenleyici Overlay - Sadece admin için */}
      <TourEditorOverlay />
    </>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <LanguageProvider>
          <AppContent />
        </LanguageProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
